import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { Button, Typography } from "@mui/material";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useTranslation } from "react-i18next";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import {
  alertError,
  alertSuccess,
  swalError,
} from "../../../components/alert/swal";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import RoomMeetingDetail from "./components/RoomMeetingDetail";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { RoomMeetingManagementApi } from "../../../api/room-meeting-management/room-meeting-management.api";
import { ROOM_MEETING_FILE_TYPE } from "../../../constants/enum";
import RoomMeetingDevice from "./components/RoomMeetingDevice";
import { BOOKING_ROOM_STATUS } from "./enum/enum";
import { produce } from "immer";
import { RootState } from "../../../store/store";
import RoomMeetingService from "./components/RoomMeetingService";
import RoomMeetingCloseService from "./components/RoomMeetingCloseService";
import { validateEmail } from "../../../utils/app.utils";

type Props = {};

const BookingRoomManagementDetail = ({ view }: { view: boolean }) => {
  const { id } = useParams();

  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;




  const defaultStateFormMeetingRoom = {
    id_meeting_type: "",
    meeting_room_name: "",
    meeting_room_limit_person: 0,
    meeting_room_location: "",
    room_meeting_email: "",
    meeting_room_internal_service_fees: 0,
    meeting_room_external_service_fees: 0,
    status: "",
  };
  const [formMeetingRoom, setFormMeetingRoom] = useState<any>(
    defaultStateFormMeetingRoom
  );
  const [coverImage, setCoverImage] = useState<any[]>([]);
  const [contentImage, setContenImage] = useState<any[]>([]);
  const [existingCoverImages, setExistingCoverImages] = useState<any[]>([]);
  const [existingContentImages, setExistingContentImages] = useState<any[]>([]);
  const [room_meeting_service_data, set_room_meeting_service_data] = useState<any[]>([]);

  const [step, setStep] = useState<number>(0);
  const [notEdit, setNotEdit] = useState<boolean>(true);
  const [dataDeviceByRoomMeeting, setDataDeviceByRoomMeeting] = useState<any[]>(
    []
  );

  const allStep: any[] = useMemo(
    () => [
      { name: t("ข้อมูลห้อง"), isAccept: !!id, icon: null, disabled: !notEdit },
      {
        name: t("ข้อมูลอุปกรณ์ภายในห้อง"),
        isAccept: !!id,
        icon: null,
        disabled: !id,
      },
      {
        name: t("ข้อมูลค่าบริการ"),
        isAccept: !!id,
        icon: null,
        disabled: !id,
      },
      {
        name: t("วันที่ปิดบริการ"),
        isAccept: !!id,
        icon: null,
        disabled: !id,
      },
    ],
    [t]
  );



  const handleDeleteCoverAndContentFile = (id_room_meeting_file: number, is_content?: boolean) => {
    if (is_content) {
      setExistingContentImages((prev) => produce(prev, (draft) => {
        const find_one = draft?.find((x) => x.id == id_room_meeting_file);
        if (find_one) find_one.status = 'inactive';
      }))
    } else {
      setExistingCoverImages((prev) => produce(prev, (draft) => {
        const find_one = draft?.find((x) => x.id == id_room_meeting_file);
        if (find_one) find_one.status = 'inactive';
      }))
    }
  }



  const getDetail = async (id_room_meeting: number) => {
    try {
      const res = await RoomMeetingManagementApi.getRoomMeetingById(
        id_room_meeting
      );

      if (res.status < 300) {

        // Process room meeting data
        setFormMeetingRoom({
          id_meeting_type: res.data.data.room_meeting_type,
          meeting_room_name: res.data.data.room_meeting_name,
          meeting_room_limit_person: res.data.data.room_meeting_amount,
          room_meeting_email: res.data.data.room_meeting_email || "",
          meeting_room_location: res.data.data.room_meeting_location,
          meeting_room_internal_service_fees:
            res.data.data.internal_service_fees,
          meeting_room_external_service_fees:
            res.data.data.external_service_fees,
          status: res.data.data.status,
        });

        setDataDeviceByRoomMeeting(res.data.data?.equipment ?? []);

        // Process file data
        if (res.data.data.files && res.data.data.files.length > 0) {
          // Filter files by type
          const coverFiles = res.data.data.files.filter(
            (file: any) => file.room_meeting_file_type === "COVER"
          );

          const contentFiles = res.data.data.files.filter(
            (file: any) => file.room_meeting_file_type === "CONTENT"
          );

          // const baseUrl = process.env.REACT_APP_FILE_BASE_API || "";

          // For cover images, use valueImage array instead of valueAddFile
          // This way the component will use its built-in image rendering logic
          const formattedCoverFiles = coverFiles.map((file: any) => ({
            file_path: file.file_path,
            file_name: file.file_name,
            file_type: file.file_type,
            is_image: file.file_type.startsWith("image/"),
            status: file.status,
            id: file.id_room_meeting_file,
          }));

          // For content images, also use valueImage
          const formattedContentFiles = contentFiles.map((file: any) => ({
            file_path: file.file_path,
            file_name: file.file_name,
            file_type: file.file_type,
            is_image: file.file_type.startsWith("image/"),
            status: file.status,
            id: file.id_room_meeting_file,
          }));

          // Update states
          setCoverImage([]); // Clear any previously uploaded files
          setContenImage([]); // Clear any previously uploaded files

          // Update the component with both existing images
          setExistingCoverImages(formattedCoverFiles);
          setExistingContentImages(formattedContentFiles);
        }
      }
    } catch (error) {
      console.log(error);
      swalError("เกิดข้อผิดพลาด");
    }
  };

  const onFetch = () => {
    if (id) {
      getDetail(+id);
    }
  };

  useEffect(() => {
    if (id) {
      getDetail(+id);
    }
  }, [id]);

  const handleSave = async (
    body?: any,
    id_room_meeting?: number | null,
    status?: string
  ) => {
    const title = status === 'ACTIVE' ? "อัพเดตห้องเรียน/ห้องประชุม" : id_room_meeting
      ? "แก้ไขห้องเรียน/ห้องประชุม"
      : "เพิ่มห้องเรียน/ห้องประชุม";
    const formData = new FormData();
    const is_email_valid = validateEmail(formMeetingRoom?.room_meeting_email)
    if (!body?.id_meeting_type) {
      return alertError("ข้อมูลไม่ครบถ้วน", "ระบุประเภทห้อง");
    } else if (!body?.meeting_room_name) {
      return alertError("ข้อมูลไม่ครบถ้วน", "ระบุชื่อการประชุม");
    } else if (!body?.room_meeting_email) {
      return alertError("ข้อมูลไม่ครบถ้วน", "ระบุอีเมลผู้รับเรื่อง");
    } else if (!is_email_valid) {
      return alertError("ข้อมูลไม่ครบถ้วน", "รูปแบบอีเมลไม่ถูกต้อง");
    }

    formData.append("room_meeting_type", body.id_meeting_type);
    formData.append("room_meeting_name", body.meeting_room_name);
    formData.append("room_meeting_location", body.meeting_room_location);
    formData.append("room_meeting_amount", body.meeting_room_limit_person);
    formData.append("room_meeting_email", body.room_meeting_email);
    formData.append(
      "external_service_fees",
      body.meeting_room_external_service_fees
    );
    formData.append(
      "internal_service_fees",
      body.meeting_room_internal_service_fees
    );
    formData.append("status", status ?? "DRAFT");

    const allFiles = [
      ...coverImage?.filter((x) => x?.status == 'active').map((file: any) => ({
        ...file, // Spread the file properties
        room_meeting_file_type: ROOM_MEETING_FILE_TYPE.COVER, // Add the file type
      })),
      ...contentImage?.filter((x) => x?.status == 'active').map((file: any) => ({
        ...file, // Spread the file properties
        room_meeting_file_type: ROOM_MEETING_FILE_TYPE.CONTENT, // Add the file type
      })),
    ];
    const allFilesEx = [
      ...existingCoverImages?.map((file: any) => ({
        ...file, // Spread the file properties
      })),
      ...existingContentImages?.map((file: any) => ({
        ...file, // Spread the file properties
      })),
    ];
    const file_to_delete: string = allFilesEx?.filter((x) => x?.status !== 'active')?.map((x) => x?.id)?.toString()

    if (file_to_delete) formData.append('filesToDelete', file_to_delete);
    // Append files and room_meeting_file_type to FormData
    allFiles.forEach(({ file, room_meeting_file_type }: any) => {
      formData.append("files", file); // Append the file
      formData.append("room_meeting_file_types", room_meeting_file_type); // Append the file type
    });


    try {
      dispatch(setLoading());
      let response: any = {};

      if (id_room_meeting) {
        response = await RoomMeetingManagementApi.updateRoomMeeting(
          id_room_meeting,
          formData,
        );
      } else {
        response = await RoomMeetingManagementApi.createRoomMeeting(formData);
      }

      if (response?.status < 300) {
        alertSuccess(`${title}`, `${title} เรียบร้อยแล้ว`, undefined, () => {
          if (id_room_meeting) {
            getDetail(id_room_meeting);
          } else {
            navigate(
              routeName.cms.BookingRoomManagement +
              "/" +
              response.data?.data.id_room_meeting +
              "/update"
            );
          }
        });
      }
      dispatch(unsetLoading());
    } catch (error) {
      alertError(`${title} ไม่สำเร็จ`);
    } finally {
      dispatch(unsetLoading());
    }
  };

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: "จัดการห้องเรียน/ห้องประชุม",
            key: "1",
            pathName: routeName.cms.BookingRoomManagement,
          },
          {
            name: view
              ? "แก้ไขห้องเรียน/ห้องประชุม"
              : "เพิ่มห้องเรียน/ห้องประชุม",
            key: "2",
            pathName: pathname
          },
        ]}
      />
      {/* header */}
      <section className="my-4">
        {view ? (
          <Typography variant="h3">แก้ไขห้องเรียน/ห้องประชุม</Typography>
        ) : (
          <Typography variant="h3">เพิ่มห้องเรียน/ห้องประชุม</Typography>
        )}
      </section>
      <section className="flex items-center justify-center">
        <StepperCustom
          sx={{ maxWidth: "fit-content" }}
          step={step}
          setStep={(num: number) => {
            setStep(num);
          }}
          stepLabel={allStep}
          view={formMeetingRoom?.status === BOOKING_ROOM_STATUS.ACTIVE}
        />
      </section>
      {step === 0 && (
        <section className="w-full mt-10">
          <RoomMeetingDetail
            formMeetingRoom={formMeetingRoom}
            setFormMeetingRoom={setFormMeetingRoom}
            coverImage={coverImage}
            setCoverImage={setCoverImage}
            contentImage={contentImage}
            setContenImage={setContenImage}
            existingCoverImages={existingCoverImages?.filter((x) => x.status == 'active')}
            existingContentImages={existingContentImages?.filter((x) => x.status == 'active')}
            isActive={false}
            // isActive={formMeetingRoom?.status === BOOKING_ROOM_STATUS.ACTIVE}
            handleDeleteImageApiContentImages={(id_file) => {
              handleDeleteCoverAndContentFile(id_file, true)
            }}
            handleDeleteImageApiCoverImage={(id_file) => {
              handleDeleteCoverAndContentFile(id_file)
            }}
          />
        </section>
      )}

      {step === 1 && (
        <section className="w-full mt-10">
          <RoomMeetingDevice
            dataDevice={dataDeviceByRoomMeeting}
            onGetData={onFetch}
            id_room_meeting={id ? Number(id) : 0}
          />
        </section>
      )}

      {step === 2 && id && (
        <RoomMeetingService
          id_room_meeting={+id}
        />
      )}

      {step === 3 && id && (
        <RoomMeetingCloseService
          id_room_meeting={+id}
        />
      )}

      <section className="col-span-12 flex items-center justify-center gap-4 my-4">
        <ButtonOutlined
          onClick={() => {
            if (step == 0) {
              if (window.history.length > 0) {
                navigate(-1)
              } else {
                navigate(routeName.cms.BookingRoomManagement);
              }
            } else {
              if (id) {
                setStep((prev) => prev - 1);
              } else {
                handleSave(formMeetingRoom, null, "DRAFT");
              }
            }
          }}
          buttonName="ย้อนกลับ"
          btnProps={{
            width: "150px",
          }}
        />
        {step === 0 && (
          <>
            {!formMeetingRoom.status || formMeetingRoom.status === "DRAFT" ? (
              <ButtonPrimary
                onClick={() => {
                  if (id) {
                    handleSave(formMeetingRoom, +id, "DRAFT");
                  } else {
                    handleSave(formMeetingRoom, null, "DRAFT");
                  }
                }}
                mode="save"
                buttonName="บันทึกร่าง"
                btnProps={{
                  width: "150px",
                }}
              />
            ) : null}
          </>
        )}

        {step === 1 && (
          <>
            {formMeetingRoom.status === "DRAFT" && (
              <ButtonPrimary
                onClick={() => {
                  if (id) {
                    handleSave(formMeetingRoom, +id, "DRAFT");
                  } else {
                    handleSave(formMeetingRoom, null, "DRAFT");
                  }
                }}
                mode="save"
                buttonName="บันทึกร่าง"
                btnProps={{
                  width: "150px",
                }}
              />
            )}
          </>
        )}

        {step !== 3 && (
          <ButtonPrimary
            onClick={() => {
              if (id) {
                setStep((prev) => prev + 1);
              } else {
                handleSave(formMeetingRoom, null, "DRAFT");
              }
            }}
            mode="next"
            buttonName="ถัดไป"
            btnProps={{
              width: "150px",
            }}
          />
        )}
        {step == 3 && (
          <ButtonPrimary
            onClick={() => {
              if (id) {
                handleSave(formMeetingRoom, +id, "ACTIVE");
              }
            }}
            mode="next"
            buttonName="ยืนยัน"
            btnProps={{
              width: "150px",
            }}
          />
        )}
      </section>


    </div>
  );
};

export default BookingRoomManagementDetail;
